import { DeleteOutlined } from "@ant-design/icons";
import { Button, Flex, Spin, Typography } from "@p0security/ui";
import { FormRow } from "components/common/FormRow";
import {
  PillSelect,
  type PillSelectOption,
} from "components/common/PillSelect";

export const IntegrationSelector: React.FC<{
  visible: boolean;
  integrationOptions: PillSelectOption<string>[];
  isLoading: boolean;
  selectedIntegration: string | undefined;
  onSelectIntegration: (value: string) => void;
  onRemove: () => void;
}> = ({
  visible,
  integrationOptions,
  isLoading,
  selectedIntegration,
  onSelectIntegration,
  onRemove,
}) => {
  if (!visible) return null;

  return (
    <Flex align="center" gap={8}>
      <Flex flex="1">
        <FormRow>
          {isLoading ? (
            <Spin size="small" />
          ) : integrationOptions.length > 0 ? (
            <PillSelect
              options={integrationOptions}
              value={selectedIntegration}
              onChange={onSelectIntegration}
              placeholder="Select an integration"
              searchable
            />
          ) : (
            <Typography.Text type="secondary">
              No integrations available
            </Typography.Text>
          )}
        </FormRow>
      </Flex>
      <Button
        type="text"
        danger
        size="small"
        onClick={onRemove}
        icon={<DeleteOutlined />}
      />
    </Flex>
  );
};
